import { put, takeEvery } from 'redux-saga/effects';
import apiCall from '../../services/api';
import { ENDPOINT } from 'src/config/endpoints';
import { saveFooterPaymentModesList, setExitGatingData } from '../actions';
import {
  FETCH_FOOTER_PAYMENT_MODES_LIST,
  GET_EXIT_GATING_DATA,
  UPLOAD_MEDIA_TO_S3,
} from '../actionTypes';
import { toastNotifyError } from '@/components/Common/Toast';

function* getExitGatingData(actions) {
  try {
    const response = yield apiCall({
      url: ENDPOINT.EXIT_GATING.getExitGatingData(actions.data),
      parseToJson: true,
    });
    if (response?.data?.status) {
      const {
        promo_details,
        exit_gating_config: {
          frequency,
          image_url,
          promo_code,
          selected_template,
          status,
          timing,
        },
      } = response.data?.data;

      yield put(
        setExitGatingData({
          status: status,
          selectedTemplate: selected_template,
          imagePath: image_url,
          minUserTimeSpent: timing,
          perDayPopUpLimit: frequency,
          offerSelected: promo_code,
          couponData: {
            discount_type: promo_details?.discounting_type,
            discount: promo_details?.discount,
            min_order_price: promo_details?.min_order_value,
            max_discount: promo_details?.max_discount,
            promo_code: promo_details?.code,
          },
        })
      );
    }
  } catch (err) {
    console.log(err);
  }
}

function* uploadMediaToS3(actions) {
  try {
    const response = yield apiCall({
      method: 'POST',
      url: ENDPOINT.LOGS.UPLOAD_IMAGE_TO_S3,
      data: actions?.data,
      parseToJson: true,
    });

    if (response?.data?.status) {
      actions?.cb?.(response?.data?.data);
    }
  } catch (err) {
    console.log(err);
    toastNotifyError(err?.message);
  }
}

function* fetchFooterPaymentModesList(actions) {
  try {
    const response = yield apiCall({
      method: 'GET',
      url: ENDPOINT.COMMON.getFooterPaymentModesList(actions.data),
      parseToJson: true,
    });
    if (response?.data?.status) {
      yield put(saveFooterPaymentModesList(response.data.data));
    }
  } catch (err) {
    console.log(err);
    toastNotifyError(err?.message);
  }
}

export default function* root() {
  yield takeEvery(GET_EXIT_GATING_DATA, getExitGatingData);
  yield takeEvery(UPLOAD_MEDIA_TO_S3, uploadMediaToS3);
  yield takeEvery(FETCH_FOOTER_PAYMENT_MODES_LIST, fetchFooterPaymentModesList);
}
